import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, Query } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { ProductAttribute, UpdateProductAttributeVariables } from '@api/graphql/types';
import { ApplicationState } from 'reducers/';
import { connect } from 'react-redux';
import ProductAttributeForm from '../components/ProductAttributeForm';

type Props = {
    id: string,
} & InjectedIntlProps & RouteComponentProps<{id: string}>;


class ProductAttributeEdit extends React.Component<Props> {
    public onSubmit = (formData: UpdateProductAttributeVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateProductAttribute, variables: formData,
        });
    }

    public render() {
        return (
            <Query<ProductAttribute> query={Queries.productAttribute} variables={{code: this.props.id}}>
                {({ loading, error, data, refetch }) => {
                    if (loading) return "Loading...";
                    if (error) return `Error! ${error.message}`;

                    return (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>{this.props.intl.formatMessage({ id: 'module.productAttribute.edit.title'})}</h5>
                                    </div>
                                    <div className="ibox-content">
                                        {(data && data.productAttribute) &&
                                            <ProductAttributeForm formData={data.productAttribute} onSubmit={this.onSubmit} refetch={refetch} />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Query>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { id } = props.match.params;
    return { id };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(ProductAttributeEdit);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/pages/ProductAttributeEdit.tsx